import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-7a87ddc3"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "van-cell"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "van-field__label"
}, "车牌号", -1));

const _hoisted_3 = {
  class: "car-box"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  style: {
    "margin": "16px",
    "margin-top": "50px"
  }
};

const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 保存 ");

const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 解绑 ");

const _hoisted_8 = {
  class: "car-group"
};
const _hoisted_9 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_field = _resolveComponent("van-field");

  const _component_van_col = _resolveComponent("van-col");

  const _component_van_cell_group = _resolveComponent("van-cell-group");

  const _component_van_button = _resolveComponent("van-button");

  const _component_van_form = _resolveComponent("van-form");

  const _component_el_drawer = _resolveComponent("el-drawer");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_van_form, {
    onSubmit: _ctx.onSubmit,
    style: {
      "margin-top": "20px"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_van_cell_group, {
      inset: ""
    }, {
      default: _withCtx(() => [_createVNode(_component_van_field, {
        label: "挪车码",
        "model-value": _ctx.form.code_sn,
        readonly: ""
      }, null, 8, ["model-value"]), _createElementVNode("div", _hoisted_1, [_hoisted_2, _createVNode(_component_van_col, {
        span: "16"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.license_plate_number, (item, index) => {
          return _openBlock(), _createElementBlock("span", {
            class: _normalizeClass(`car-input ${_ctx.chooseClass(index)}`),
            onClick: $event => _ctx.handleCar(index),
            key: index
          }, _toDisplayString(item), 11, _hoisted_4);
        }), 128)), !_ctx.isNewEnergy ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = (...args) => _ctx.newEnergy && _ctx.newEnergy(...args)),
          class: "car-input car-new"
        })) : _createCommentVNode("", true)])]),
        _: 1
      })]), _createVNode(_component_van_field, {
        modelValue: _ctx.form.phone_number,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.form.phone_number = $event),
        onInput: _ctx.onInputPhone,
        type: "tel",
        label: "手机号",
        maxlength: "11",
        placeholder: "手机号",
        rules: [{
          required: true,
          message: '请填写手机号'
        }, {
          validator: _ctx.validator,
          message: '请输入正确手机号'
        }]
      }, null, 8, ["modelValue", "onInput", "rules"])]),
      _: 1
    }), _createElementVNode("div", _hoisted_5, [_createVNode(_component_van_button, {
      round: "",
      block: "",
      type: "primary",
      "native-type": "submit"
    }, {
      default: _withCtx(() => [_hoisted_6]),
      _: 1
    }), _ctx.form.is_bind == 1 ? (_openBlock(), _createBlock(_component_van_button, {
      key: 0,
      round: "",
      block: "",
      plain: "",
      hairline: "",
      type: "default",
      style: {
        "margin-top": "10px"
      },
      onClick: _ctx.onUnbind
    }, {
      default: _withCtx(() => [_hoisted_7]),
      _: 1
    }, 8, ["onClick"])) : _createCommentVNode("", true)])]),
    _: 1
  }, 8, ["onSubmit"]), _createVNode(_component_el_drawer, {
    modelValue: _ctx.show,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.show = $event),
    direction: "btt",
    size: "30%",
    "show-close": false,
    "with-header": false
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.keys, (item, i) => {
      return _openBlock(), _createElementBlock("div", {
        class: "car-row",
        key: i
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (item2, index2) => {
        return _openBlock(), _createElementBlock("span", {
          onClick: $event => _ctx.handleKey(item2),
          class: "car-cell",
          key: index2
        }, _toDisplayString(item2), 9, _hoisted_9);
      }), 128)), _ctx.index == 7 && i == 3 ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "car-cell-cancel",
        onClick: _cache[2] || (_cache[2] = (...args) => _ctx.handleRemove && _ctx.handleRemove(...args))
      }, " 删除 ")) : _createCommentVNode("", true)]);
    }), 128))])]),
    _: 1
  }, 8, ["modelValue"])], 64);
}